import { CustomPill } from '@joor/design-system'

import { EMPTY_CELL_CONTENT } from 'shop/products/utils'

import { PaymentStatusesType } from '../joorPayOrders.types'

export function PaymentStatusCell({
  value,
  valueFormatted,
}: {
  value: PaymentStatusesType | string
  // allowing to use a valueFormatter in columnDefs to format the value
  // this is an Ag Grid injected prop
  valueFormatted?: PaymentStatusesType | string
}) {
  const statusValue = valueFormatted ?? value

  if (statusValue === EMPTY_CELL_CONTENT) {
    return <>{statusValue}</>
  }

  const bgColor = getColorForPaymentStatus(statusValue as PaymentStatusesType)

  return (
    <CustomPill bgColor={bgColor} color={'var(--color-primary-900)'}>
      {statusValue}
    </CustomPill>
  )
}

export function getColorForPaymentStatus(status: PaymentStatusesType) {
  switch (status) {
    case 'Paid':
      return 'var(--color-success-300)'
    case 'Partially Paid':
      return 'var(--color-warning-300)'
    case 'Processing':
      return 'var(--color-warning-300)'
    case 'Unpaid':
      return 'var(--color-error-300)'
  }
}
